<template>
    <div class="custom-settings-popover">
        <div class="filter-settings filter-settings-wrapper">
            <v-bar wrapper="v-bar-filter-settings">
                <div class="subtitle">
                    фильтрация по:
                </div>
                <el-form label-position="top" class="deal-filter-main" @keyup.enter.native="filterApplied">
                    <el-form-item :label="fieldsNames.name" v-if="isColumnVisible('name')">
                        <el-input v-model="filterModel.name" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_phones" v-if="isColumnVisible('contact_phones')">
                        <el-input v-model="filterModel.phone" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.email" v-if="isColumnVisible('email')">
                        <el-input v-model="filterModel.email" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.birthday" v-if="isColumnVisible('birthday')">
                        <el-date-picker
                            v-model="filterModel.birthday"
                            type="date"
                            placeholder="день.месяц.год"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="timestamp"
                            size="mini"
                            class="w100"
                            :picker-options="pickerOptions"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.company_id" v-if="isColumnVisible('company_id')">
                        <el-select
                            v-model="filterModel.company_id"
                            multiple
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            :placeholder="fieldsNames.company_id"
                            :remote-method="searchCompany"
                            size="mini"
                        >
                            <el-option
                                v-for="item in companyOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="actions-wrapper">
                    <div class="btn btn-default grey" @click="hideFilterSettings">
                        отменить
                    </div>
                    <div class="btn btn-default orange" @click="filterApplied">
                        применить
                    </div>
                </div>
            </v-bar>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import { pickerOptions } from '@/common/pickerOptions';
import VBar from 'v-bar';

export default {
    name: 'ContactsListFilterSettingsMobile',
    data() {
        return {
            pickerOptions,
            fieldsNames: {}
        };
    },
    components: { VBar },
    props: {
        attributes: {
            type: Object,
            default: () => {}
        },
        filter: {
            type: Object,
            default: () => {}
        },
        companyOptions: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        hideFilterSettings() {
            eventBus.$emit('hideFilterSettings');
        },
        filterApplied() {
            this.$emit('filterApplied', this.filterModel);
            this.hideFilterSettings();
        },
        isColumnVisible(colId) {
            return this.attributes[colId].hide === false;
        },
        searchCompany(query) {
            if (query !== '') {
                this.companyOptions = this.companies.filter(
                    item => item.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
            } else {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            }
        }
    },
    mounted() {
        Object.keys(this.attributes).forEach((item) => {
            this.$set(this.fieldsNames, item, this.attributes[item].name);
        });
    },
    computed: {
        filterModel() {
            return this.filter;
        },
        companies() {
            return this.$store.state.references.companies;
        }
    }
};
</script>
